import type { ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

import { PharaohNextScope } from '#/lib/pharaoh-next/pharaoh-next-scope.tsx'

export function PendingSubscriptionPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <PharaohNextScope>
      <LoadingRegion label={translate('loading_aria_label')}>
        {/* TODO: use View's future compact-width API here and in PendingSubscriptionChoice
            instead of duplicating the base and desktop max-width overrides. */}
        <View.Root
          className="
            max-w-[600px]
            lg:max-w-[600px]
          "
        >
          <View.Header>
            <Skeleton variant="text" width="80%" height={32} />
          </View.Header>
          <View.Body>
            <div className="flex flex-col gap-stack">
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="70%" height={24} />
            </div>
            <div
              className="
                flex flex-col-reverse gap-inline
                md:flex-row md:justify-between
              "
            >
              <Skeleton variant="block" height={48} className="md:w-1/2" />
              <Skeleton variant="block" height={48} className="md:w-1/2" />
            </div>
          </View.Body>
        </View.Root>
      </LoadingRegion>
    </PharaohNextScope>
  )
}
